import eventQueue from '../queue';
import { EventAction } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('link_api_action', function (_a) {
        var action = _a.action, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (action.actionType === 'payload' && action.payload.resend_code) {
            return fireAnalyticsEvent(EventAction.RESEND_CODE);
        }
        return null;
    });
}
attachEventListeners();
